import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="bg-sand-50 text-foreground min-h-[80vh] flex items-center justify-center px-6 py-20">
      <div className="max-w-md text-center flex flex-col items-center gap-6">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-clay-100 text-clay-700">
          <i className="fa-light fa-compass-slash text-4xl" />
        </div>
        <h1 className="font-serif text-4xl font-bold text-black tracking-wide">
          Siden blev ikke fundet
        </h1>
        <p className="text-foreground/70 leading-relaxed">
          Beklager, men den side du leder efter findes ikke eller er blevet flyttet. Du kan altid vende tilbage til forsiden.
        </p>
        <Link
          to="/"
          className="rounded-full bg-cta hover:bg-cta-hover text-clay-900 py-3 px-8 text-xs uppercase tracking-widest font-bold transition-all shadow-md active:scale-98"
        >
          Gå til forsiden
        </Link>
      </div>
    </div>
  );
}
